import { GridColDef } from "@mui/x-data-grid";

export const proposalLineItemColumns: GridColDef[] = [
  { field: "display", headerName: "Display", flex: 1 },
  { field: "price", headerName: "Price", flex: 1 },
  { field: "addToTotal", headerName: "Add To Total", flex: 1 },
];
